import React from "react";

import './Calender.css';

export default function Calender() {
    return (
        <div className="calenderBox">
            <div className="calender-content">
                <h2 className="title">May, 2020</h2>
                <div className="box-container">
                    <div className="empty-box"></div>
                    <div className="empty-box"></div>
                    <div className="box"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box17">17</div>
                    <div className="box active"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box active"></div>
                    <div className="box"></div>
                </div>
            </div>
        </div>
    )
}